import { Inject, Injectable } from '@angular/core';
import _, { result } from 'lodash';

//enumeration imports 
import {Role} from '../enumerations/role.enumeration';
import {Permission} from '../enumerations/permission.enumeration';
import {PersonType} from '../enumerations/person-type.enumeration';
import {FarmStatus} from '../enumerations/farm-status.enumeration';
import {PersonRoleStatus} from '../enumerations/person-role-status.enumeration';
import {PersonStatus} from '../enumerations/person-status.enumeration';




@Injectable({
    providedIn: 'root',
})
export class MySynchEnumerationService {

    private enumerationTypeTmpl:object = { name:'', items:{} };
    private enumereationItemTmpl:object = { value: -1, text: ''};
    private enumerations:object = {};

    constructor( @Inject('ApiFactory') private api:any){
     this.initializeEnumerations();
    }

    private getAllEnumerations(){
        return new Promise((resolve,reject)=>{
             this.api.getMySynchEnumerations((err, result)=>{
                 if(_.isNull(result) || _.isUndefined(result)){
                    resolve([]);
                 }else{
                    resolve(result);
                 }
             })
        });
    }
    private getSingleEnumeration(enumType:String, enumKey:String){
        return new Promise((resolve,reject)=>{
            this.api.getMySynchEnumeration(enumType,enumKey,(err, result)=>{
                if(_.isNull(result) || _.isUndefined(result)){
                   resolve(null);
                }else{
                   resolve(result);
                }
            })
       });
    }

    private buildMySynchEnumerations(enumerationData:Array<object>){
         var enumerations = {}
         var enumerationTypes = _.uniq(_.map(enumerationData,'name'));

         _.forEach(enumerationTypes,(enumerationType)=>{
              var enumerationsDataByType = _.filter(enumerationData,{name:enumerationType});
              
              var enumeration = _.cloneDeep(this.enumerationTypeTmpl);
              _.set(enumeration,'name',enumerationType);

              var enumerationItems = {};
              _.forEach(enumerationsDataByType,(enumerationsDataByTypeItem)=>{
                 
                 var enumerationItem = _.cloneDeep(this.enumereationItemTmpl);
                 var enumerationKey = _.get(enumerationsDataByTypeItem,'key');
                 _.set(enumerationItem,'name',enumerationKey);
                 _.set(enumerationItem,'value',_.get(enumerationsDataByTypeItem,'value'));
                 _.set(enumerationItem,'text',_.get(enumerationsDataByTypeItem,'text'));
                 
                 _.set(enumerationItems,enumerationKey,enumerationItem);

              })
              _.set(enumeration,'items',enumerationItems);

              _.set(enumerations,enumerationType,enumeration);
              

         });
         return enumerations;
    }
   
    refreshMySynchEnumerations(){
        return new Promise((resolve,reject)=>{
            this.getAllEnumerations().then((enumerationData:Array<object>)=>{
                
                if(!_.isEmpty(enumerationData) && !_.isNull(enumerationData) && !_.isUndefined(enumerationData)){
                    var enumerationsObj = this.buildMySynchEnumerations(enumerationData);
                    this.enumerations = _.cloneDeep(enumerationsObj);
                }
                resolve(this.enumerations);
            });
        });
    }
    initializeEnumerations(){
         // set default enumerations
         _.set(this.enumerations,Role.name,Role);
         _.set(this.enumerations,Permission.name,Permission);
         _.set(this.enumerations,PersonType.name,PersonType);
         _.set(this.enumerations,FarmStatus.name,FarmStatus);
         _.set(this.enumerations,PersonRoleStatus.name,PersonRoleStatus);
         _.set(this.enumerations,PersonStatus.name,PersonStatus);
         // refresh enumerations from sql
         this.refreshMySynchEnumerations();
        
    }
    getMySynchEnumeration(enumType:String,enumKey:String){
        var enumeration = {};
        var enumerationType = _.get(this.enumerations,`${enumType}`)
        enumeration = _.get(enumerationType,`items.${enumKey}`);
        return enumeration;
    }
    getMySynchEnumerationValue(enumType:String,enumKey:String){
        var enumeration = {};
        var enumerationType = _.get(this.enumerations,`${enumType}`)
        enumeration = _.get(enumerationType,`items.${enumKey}`);
        var value = _.get(enumeration,'value');
        return value;
    }

    getMySynchEnumerationItems(enumType:String){
        var enumerationItems = _.get(this.enumerations,`${enumType}.items`);
        return enumerationItems;
    }
    getMySynchEnumerationValues(enumType:String){
        var enumerationItems = _.get(this.enumerations,`${enumType}.items`,[]);
        return _.map(enumerationItems,(enumeration)=>{
                return _.get(enumeration,"value");
        });
    }

    getMySynchEnumerationName(enumType:String,enumKey:String){
        var enumerationType =  _.get(this.enumerations,`${enumType}`);
        return _.get( _.get(enumerationType,`items.${enumKey}`),'name');
    }


    
}   